import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import Grid from '@mui/material/Grid2'
import { Scrollbar } from 'components/UI'
// utils
import { ellipsis } from 'polished'

const CategoryTitle = styled('div')`
  font-size: 12px;
  font-weight: bold;
  margin-top: 16px;
`

const OptionWrapper = styled('div')`
  align-items: center;
  display: flex;
  margin-top: 8px;
  max-width: 255px;

  &:hover {
    font-weight: 500;
  }

  div:first-child {
    margin-right: 8px;
  }
`

const Option = styled('div')`
  cursor: pointer;
  width: 100%;

  ${ellipsis('100%')};
`

const InnerWrapper = styled(Scrollbar)`
  height: 294px;
  padding-bottom: 8px;
`

const Wrapper = styled((props) => <Grid {...props} />)`
  min-height: 350px;
  padding: 16px 0 16px 16px;

  > div:first-child {
    margin-right: 16px;
    width: auto;
  }
`

export { CategoryTitle, Option, OptionWrapper, InnerWrapper, Wrapper }
